import { render, staticRenderFns } from "./MakePayrollExcel.vue?vue&type=template&id=76b18bc6"
import script from "./MakePayrollExcel.vue?vue&type=script&lang=js"
export * from "./MakePayrollExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports